<div class="modal-header ">
  <h4 class="modal-title header-5">
    {{ configs.title }}
  </h4>
  <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        " alt="close"
      />
    </button>
</div>
@if(isLoading){
<div
  class="loading-div w-100 d-flex justify-content-center align-items-center"
  *ngIf="isLoading"
>
  <app-loading [text]="'Loading...'"></app-loading>
</div>
} @else{
    @if(configs?.type === 'grid') {

    <div class="grid-view">

      <div class="grid-column">
        <div *ngFor="let field of leftFields" class="grid-item">
          <div class="grid-label">{{ field.name }}</div>
          <div class="grid-value">
            <ng-container *ngIf="isFieldLoading(field)">
              <span class="text-muted">Loading...</span>
            </ng-container>
            <ng-container *ngIf="!isFieldLoading(field) && field.type === 'password-input'">
              <span>
                {{
                  showPassword[field.key]
                    ? (data?.[field.key] || data?.[field.key])
                    : getMaskedValue(data?.[field.key] || data?.[field.key])
                }}
              </span>
              <span
                class="ms-2 cursor-pointer material-symbols-outlined eye-visibility"
                (click)="togglePassword(field.key)" (keydown.enter)="togglePassword(field.key)"
                [title]="
                  showPassword[field.key]
                    ? 'Hide Password'
                    : 'Show Password'
                "
              >
                {{ showPassword[field.key] ? 'visibility_off' : 'visibility' }}
              </span>
            </ng-container>

            <ng-container *ngIf="!isFieldLoading(field) && field.type === 'edit-text'">
              <input 
                id="edit-field"
                type="text" 
                class="form-control" 
                [(ngModel)]="data[field.key]"
                [placeholder]="field.placeholder || 'Enter ' + field.name"
              />
            </ng-container>

            <ng-container *ngIf="!isFieldLoading(field) && field.type !== 'password-input' && field.type !== 'edit-text'">
              {{ data?.[field.key] || data?.[field.key] || '-' }}
            </ng-container>

          </div>
        </div>
      </div>

      <div class="grid-column">
        <div *ngFor="let field of rightFields" class="grid-item">
          <div class="grid-label">{{ field.name }}</div>
          <div class="grid-value">
            <ng-container *ngIf="isFieldLoading(field)">
              <span class="text-muted">Loading...</span>
            </ng-container>
            <ng-container *ngIf="!isFieldLoading(field) && field.type === 'password-input'">
              <span>
                {{
                  showPassword[field.key]
                    ? (data?.[field.key] || data?.[field.key])
                    : getMaskedValue(data?.[field.key] || data?.[field.key])
                }}
              </span>
              <span
                class="ms-2 cursor-pointer material-symbols-outlined eye-visibility"
                (click)="togglePassword(field.key)" (keydown.enter)="togglePassword(field.key)"
                [title]="
                  showPassword[field.key]
                    ? 'Hide Password'
                    : 'Show Password'
                "
              >
                {{ showPassword[field.key] ? 'visibility_off' : 'visibility' }}
              </span>
            </ng-container>

            <ng-container *ngIf="!isFieldLoading(field) && field.type === 'edit-text'">
              <input 
                id="test-field"
                type="text" 
                class="form-control" 
                [(ngModel)]="data[field.key]"
                [placeholder]="field.placeholder || 'Enter ' + field.name"
              />
            </ng-container>

            <ng-container *ngIf="!isFieldLoading(field) && field.type !== 'password-input' && field.type !== 'edit-text'">
              {{ data?.[field.key] || data?.[field.key] || '-' }}
            </ng-container>

          </div>
        </div>
      </div>

    </div>

    } @else {

    <!-- EXISTING VIEW -->
    <div class="modal-body ">
      <div class="row">
        <div class="col-md-12">
          <div *ngFor="let item of mainFields">
            <div class="d-flex py-1">
              <div class="col-4 header-8 m-auto">{{ item.name }}</div>
              <div class="col-8 header-coverage">{{ data?.[item.key] || '-' }}</div>
            </div>
          </div>

          @if(configs.subTitle){
          <div class="col-12 header-9 mt-2">{{ configs.subTitle }}</div>

          <div *ngFor="let field of selectedFields">
            <div class="d-flex py-1">
              <div class="col-4 header-8" [class.d-none]="!field.name">{{ getFieldLabel(field) }}</div>
              <div class="col-8 d-flex flex-row align-items-center">
                <ng-container
                  *ngIf="field.type === 'password-input'; else normalText"
                >
                  <span class="header-coverage">
                    {{
                      showPassword[field.key]
                        ? getFieldValue(field)
                        : getMaskedValue(getFieldValue(field))
                    }}
                  </span>
                  <span
                    class="ms-2 cursor-pointer material-symbols-outlined eye-visibility"
                    (click)="togglePassword(field.key)"
                    [title]="
                      showPassword[field.key] ? 'Hide Password' : 'Show Password'
                    " (keydown.enter)="togglePassword(field.key)"
                  >
                    {{ showPassword[field.key] ? "visibility_off" : "visibility" }}
                  </span>
                </ng-container>
              </div>

              <ng-template #normalText>
                @if(field.type === 'checkbox'){
                  <div class="checkbox-div">
                    <input id ="checkbox-input" class="form-check-input" type="checkbox" [checked]="field.value" [disabled]="field.disabled" />
                    <span class="px-2 checkbox-placeholder form-check-label general-text-6"> {{ field?.placeholder }} </span>
                  </div>
                } @else {
                <div class="col-12 header-coverage">
                  {{ getFieldValue(field) || '-' }}
                </div>  
                }
              </ng-template>
            </div>
          </div>

          <!-- Expanded additional_attributes entries -->
          <div *ngFor="let entry of additionalAttributeEntries">
            <div class="d-flex py-1">
              <div class="col-4 header-8">{{ entry.label }}</div>
              <div class="col-8 header-coverage">{{ entry.value }}</div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }

<div class="modal-footer">
  <div class="d-flex justify-content-end w-100">
    <button *ngIf="configs?.isCancelBtn"
      class="btn btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('cancel')"
    >
      Cancel
    </button>
    <button
      class="btn btn-accello-primary-light"
      (click)="buttonClick()"
    >
      {{configs?.buttonText || 'Close'}}
    </button>
  </div>
</div>
}
